angular
	.module 'App.Module.EntityManagement', []
	.config ($stateProvider, DEFAULT_RESOLVE_POLICY) ->
		$stateProvider
			.state 'import-and-export',
				url: '/import-and-export',
				views:
					main:
						controller: 'MainCrudController'
						controllerAs: 'mainCrud'
						templateUrl: '@app/layout/views/app.entity-administration.view.html'
					"entity_search@import-and-export":
						templateUrl: '@app/layout/views/app.entity-search.view.html'
						controller: 'BaseSearchController'
						controllerAs: 'search'
				data:
					restrict: 'Backoffice.TopMenu.ImportAndExport.Enabled'
					searchParams:
						itemTemplate: '@app/bulk-data/bulk-data.search-result.view.html'
						repositoryName: 'BulkDataRepository'
						title: 'general.entities'
						filterEnabled: false
						createEnabled: false

			.state 'import-and-export.edit',
				url: '/:id'
				views:
					entity_view:
						templateUrl: '@app/layout/views/app.entity-container.view.html'

			.state 'import-and-export.edit.details',
				url: '/edit?eventId&sessionId&ticketTypeId',
				params:
					eventId:
						value: null
					sessionId:
						value: null
					ticketTypeId:
						value: null
				views:
					entity_sub_view:
						controller: 'BulkDataController'
						controllerAs: 'vm'
						templateUrl: ($stateParams) ->
							if !$stateParams.id
								return

							identifier = $stateParams.id.replace(/_/g, '-')

							return "@app/bulk-data/#{identifier}/#{identifier}.view.html"
				resolvePolicy: DEFAULT_RESOLVE_POLICY
				resolve:
					priceRegions: (PriceRegionRepository, $stateParams) ->
						return if $stateParams.id == 'products' then PriceRegionRepository.getEntities() else []
					user: (UserInformation, $stateParams) ->
						if $stateParams.id != 'products'
							return null

						return UserInformation.getSubUser()
					ticketEvents: (TicketEventRepository, $stateParams) ->
						return if $stateParams.id == 'tickets' then TicketEventRepository.getEntities() else []
					ticketEventSessions: (TicketEventSessionRepository, $stateParams) ->
						return if $stateParams.id == 'tickets' then TicketEventSessionRepository.getEntities() else []
					ticketTypes: (TicketTypeRepository, $stateParams) ->
						return if $stateParams.id == 'tickets' then TicketTypeRepository.getEntities() else []
